// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X3N_0","title":"styles_title__flcik"};